export default __webpack_public_path__ + "static/media/4.24dd3cd0.mp4";